import type { ActionHandler } from '../types'
import { GRADE_LEVELS } from '../types'

export const handleHealWound: ActionHandler<'HEAL_WOUND'> = async (ctx, payload) => {
  const { data: old } = await ctx.supabase
    .from('character_injuries')
    .select('grade, injury_levels, healed_at')
    .eq('id', payload.injury_id)
    .single()

  if (!old) throw new Error('Injury not found')

  const effects = []

  if (payload.healed) {
    const now = new Date().toISOString()
    const { error } = await ctx.supabase
      .from('character_injuries')
      .update({ healed_at: now })
      .eq('id', payload.injury_id)
    if (error) throw error

    effects.push({
      character_id: ctx.characterId,
      target_table: 'character_injuries',
      target_row_id: payload.injury_id,
      target_field: 'healed_at',
      operation: 'UPDATE' as const,
      old_value: old.healed_at,
      new_value: now,
    })
  } else if (payload.new_grade) {
    const newLevels = GRADE_LEVELS[payload.new_grade] ?? 1
    const { error } = await ctx.supabase
      .from('character_injuries')
      .update({ grade: payload.new_grade, injury_levels: newLevels })
      .eq('id', payload.injury_id)
    if (error) throw error

    effects.push(
      { character_id: ctx.characterId, target_table: 'character_injuries', target_row_id: payload.injury_id, target_field: 'grade', operation: 'UPDATE' as const, old_value: old.grade, new_value: payload.new_grade },
      { character_id: ctx.characterId, target_table: 'character_injuries', target_row_id: payload.injury_id, target_field: 'injury_levels', operation: 'UPDATE' as const, old_value: old.injury_levels, new_value: newLevels },
    )
  }

  return {
    effects,
    label: payload.healed ? 'Wound healed' : `Wound improved to ${payload.new_grade}`,
  }
}
